import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

export class Layout extends Component {
    static displayName = Layout.name;

    render() {
        const PageComponent = this.props.component;
        return (
            <div>
                <NavMenu {...this.props}/>
                <Container >
                    <div className="inContainer">
                        <Grid container spacing={3} direction="row" alignItems="flex-end">

                            <Grid item xs={6}>
                                <Typography variant="h4" gutterBottom>
                                    {this.props.title}
                                </Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <div style={{ textAlign: 'center', float: 'right' }}>
                                    <img src="/images/financed.png" alt="" width="183px" height="93px" />
                                    <Typography variant="caption" display="block" gutterBottom>
                                        This project is co-financed by the European Union
                                    </Typography>
                                    <Typography variant="caption" display="block" gutterBottom>
                                        and the Republic of Turkey.
                                    </Typography>
                                </div>
                            </Grid>
                        </Grid>
                        <PageComponent {...this.props} />
                    </div>
                    <Divider />
                    <div align="center">
                        <img src="/images/cfcu.png" alt="" width="62px" height="66px" />
                        <img
                            src="/images/eptisa.png"
                            alt=""
                            width="105px"
                            height="80px"
                            style={{ marginLeft: 120, marginRight: 120 }}
                        />
                        <img src="/images/europan.png" alt="" width="46px" height="46px" />
                    </div>
                </Container>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/Layout.js